import { useQuery } from '@tanstack/react-query';
import axiosInstance from '../utils/axios';
import { GATEWAY_PROFILE_LIST } from 'src/constants/queryKeys';

export const networkGetGatewayProfileList = async (payload, pageIndex = 0, pageSize = 50) => {
  const res = await axiosInstance.post(`GatewayProfile/List/${pageIndex}/${pageSize}`, payload);
  return res;
};

export function useFetchGatewayProfileList(payload, pageIndex = 0, pageSize = 50) {
  return useQuery({
    queryKey: [GATEWAY_PROFILE_LIST, payload, pageIndex],
    queryFn: () => networkGetGatewayProfileList(payload, pageIndex, pageSize),
  });
}

export const networkGetGatewayProfileInfo = async (id) => {
  const res = await axiosInstance.post(`GatewayProfile/Info/${id}`);
  return res;
};

export function useFetchGatewayProfileInfo(id) {
  return useQuery({
    queryKey: ['gateway-profile-info', id],
    queryFn: () => networkGetGatewayProfileInfo(id),
  });
}

export const networkCreateGatewayProfile = async (data) => {
  const res = await axiosInstance.post('GatewayProfile/Insert', data);
  return res;
};

export const networkUpdateGatewayProfile = async (id, data) => {
  const res = await axiosInstance.post(`GatewayProfile/Update/${id}`, data);
  return res;
};

export const networkRemoveGatewayProfile = async (id) => {
  const res = await axiosInstance.post(`GatewayProfile/Remove/${id}`);
  return res;
};
